export default __webpack_public_path__ + "static/media/netflix.cb30299d.svg";